import { twMerge } from 'tailwind-merge';
import { BaseButton } from '@repo/common';
import { ReactComponent as BackpackIcon } from '@repo/common/assets/icons/32px/icon_32px_backpack_outline.svg';

/**
 * 큰 카드형 단일 선택 컴포넌트 — SINGLE_SELECT_CARD answer_type 전용
 * options: [{ id, title, caption }]
 * value: 선택된 option id 또는 null
 * onChange: (id: string) => void
 */
function PathfinderSelectCardGroup({ options = [], value, onChange }) {
  return (
    <div className='grid w-full grid-cols-2 gap-4'>
      {options.map((opt) => {
        const selected = value === opt.id;
        return (
          <BaseButton
            key={opt.id}
            type='text'
            size='m'
            htmlType='button'
            hideIcon
            typo={false}
            isStatic
            onClick={() => onChange(opt.id)}
            textWrapperClass='flex h-full w-full flex-col items-center justify-center gap-4'
            className={twMerge(
              'group h-auto min-w-0 cursor-pointer flex min-h-[200px] flex-col items-center justify-center gap-4 rounded-[15px] border-2 p-6 text-center transition-[background-color,border-color,box-shadow,opacity] duration-300 ease-out',
              selected
                ? 'border-surface-green40 bg-green-light01 shadow-[0_10px_30px_rgba(0,158,79,0.08)]'
                : 'border-transparent bg-surface-lightgray60 opacity-[0.94] hover:border-surface-green40 hover:bg-green-light01 hover:opacity-100 hover:shadow-[0_10px_30px_rgba(0,158,79,0.08)]'
            )}
          >
            {/* 아이콘 컨테이너 */}
            <div
              className={twMerge(
                'flex h-12 w-12 shrink-0 items-center justify-center rounded-[8px] transition-colors duration-300 ease-out',
                selected
                  ? 'bg-[rgba(0,158,79,0.10)]'
                  : 'bg-[rgba(236,233,228,0.50)] group-hover:bg-[rgba(0,158,79,0.10)]'
              )}
            >
              <BackpackIcon
                className={twMerge(
                  'size-8 transition-colors duration-300 ease-out',
                  selected
                    ? 'text-green-deep02'
                    : 'text-text-placeholder group-hover:text-green-deep02'
                )}
              />
            </div>

            {/* 텍스트 */}
            <div className='flex flex-col items-center gap-[2px]'>
              <span
                className={twMerge(
                  'text-base font-medium leading-[1.5] transition-colors duration-300 ease-out',
                  selected
                    ? 'text-green-deep02'
                    : 'text-text-tertiary group-hover:text-green-deep02'
                )}
              >
                {opt.title}
              </span>
              {opt.caption && (
                <span
                  className={twMerge(
                    'text-[13px] font-normal leading-[1.4] text-center transition-colors duration-300 ease-out',
                    selected
                      ? 'text-green-deep02'
                      : 'text-text-placeholder group-hover:text-green-deep02'
                  )}
                >
                  {opt.caption}
                </span>
              )}
            </div>
          </BaseButton>
        );
      })}
    </div>
  );
}

export default PathfinderSelectCardGroup;
